import { styled } from "@mui/material/styles";
import { HubCardStack } from "../../components";
import { Stack } from "@mui/material";

export const StyledPrintWrapper = styled("div")({
  display: "contents",
});

export const StyledCardStack = styled(HubCardStack, {
  shouldForwardProp: (prop) => !["transparent", "margin"].includes(prop),
})(({ theme, transparent, margin }) => ({
  backgroundColor: transparent
    ? "transparent"
    : theme.palette?.mainDark === "#FFFFFF"
      ? theme.palette.hubColors.greyLightest
      : theme.palette.hubColors.white,
  padding: `${margin}in`,
  overflowX: "hidden",
  "@media print": {
    border: "none",
    padding: "0px",
    boxShadow: "none !important",
  },
}));

export const StyledBaseStack = styled(Stack, {
  shouldForwardProp: (prop) =>
    !["width", "margin", "pageless", "fixedHeight"].includes(prop),
})(({ width, margin, fixedHeight, pageless }) => ({
  width: `calc(${width} - ${margin * 2}in - 2px)`,
  ...(pageless
    ? { minHeight: `calc(${fixedHeight} - ${margin * 2}in - 2px)` }
    : { height: `calc(${fixedHeight} - ${margin * 2}in - 2px)` }),
  gap: "15px",
  "@media print": {
    width,
  },
}));
